import React from 'react';
import {useCollapse} from 'react-collapsed';




function Collapse(props) {
    const config = {
        defaultExpanded: props.defaultExpanded ,
        collapsedHeight: props.collapsedHeight || 0
    };
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse(config);
return (
    <div className="collapsible" >
        <div className="header" {...getToggleProps()}>
            <div className="title">{props.title}</div>
            <div className="icon">
                <i className={'fas fa-chevron-circle-' + (isExpanded ? 'up' : 'down')}></i>
            </div>
        </div>
        <div {...getCollapseProps()}>
            <div className="content" style={{margin:"0",padding:"0"}}>
                {props.children}
            </div>
        </div>
    </div>
    );
}
export default Collapse